import type { ComponentProps } from 'react';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/UI/Box';

type CardVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'info'
  | 'warning'
  | 'error';

interface CardProps extends Omit<ComponentProps<typeof Box>, 'variant'> {
  variant?: CardVariant;
}

export default function Card({
  children,
  style: extraStyles,
  variant,
  ...props
}: CardProps) {
  style.useVariants({
    variant,
  });

  return (
    <Box {...props} style={[style.container, extraStyles]}>
      {children}
    </Box>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    borderRadius: theme.borderRadius.xl,
    borderWidth: theme.size(0.5),
    borderColor: theme.colors.borderMuted,
    overflow: 'hidden',
    variants: {
      variant: {
        primary: {
          borderColor: theme.colors.primary,
        },
        secondary: {
          borderColor: theme.colors.secondary,
        },
        success: {
          borderColor: theme.colors.success,
        },
        info: {
          borderColor: theme.colors.info,
        },
        warning: {
          borderColor: theme.colors.warning,
        },
        error: {
          borderColor: theme.colors.error,
        },
        default: {
          borderColor: theme.colors.borderMuted,
        },
      },
    },
  },
}));
